const IconSorting = (): JSX.Element => {
  return (
    <>
      <path
        d="M7 16V4M7 4L3 8M7 4L11 8M17 8V20M17 20L21 16M17 20L13 16"
        stroke="#2F2D2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );
};

export default IconSorting;
